import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const Lang = () => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState<string>("jp");

  const changeLang = (lang: string) => {
    setLang(lang);
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  return {
    t,
    lang,
    changeLang,
  };
};
